// services/paymentMethodService.js
import axios from 'axios';
import Api from '../api/ApiUrl'
const config = {
  headers: {
      // Authorization: `Bearer ${Cookies.get('token')}`,
      role: 'admin'
  },
};
const API_URL = `${Api}/api/v1/paymentmethodinfo`;

export const getPaymentMethods = async () => {
  const response = await axios.get(API_URL,config);
  return response.data.data.paymentMethods;
};

export const getPaymentMethod = async (id) => {
  const response = await axios.get(`${API_URL}/${id}`,config);
  return response.data.data.paymentMethod;
};

export const createPaymentMethod = async (paymentMethod) => {
  const response = await axios.post(API_URL, paymentMethod,config);
  return response.data.data.paymentMethod;
};

export const updatePaymentMethod = async (id, paymentMethod) => {
  const response = await axios.patch(`${API_URL}/${id}`, paymentMethod,config);
  return response.data.data.paymentMethod;
};

export const deletePaymentMethod = async (id) => {
  await axios.delete(`${API_URL}/${id}`,config);
};
